// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".principle-container{padding-top:100px}@media (min-width:964px){.principle-container{padding-top:200px;padding-bottom:115px}}.parallax-img-container{z-index:55;position:relative}.principle-image{max-width:100%;max-height:100%;width:auto;height:auto}", ""]);
// Exports
module.exports = exports;
